"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _order = require("@/api/order");
var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));
var _default = {
  components: {
    cropUpload: _cropUpload.default
  },
  props: ['orderId', 'orderInfo', 'openAccount', 'collectionReport'],
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      activeName: 'supplier',
      infoData: {},
      dataList: [],
      innerVisible: false,
      innerTitle: '',
      folwForm: {
        logistics_name: '',
        logistics_no: '',
        cost_price: 0
      },
      editCode: 'logistics_name',
      logisticsNames: []
    };
  },
  methods: {
    handleOpenAccount: function () {
      var _handleOpenAccount = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$confirm('确认要征信开户吗?', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                }).then(function () {
                  _this.loading = true;
                  console.log('订单参数信息', _this.orderInfo);
                  // console.log('当前选中的orderInfo', orderInfo)
                  // 发起开户上报征信之前，需要确保所需参数已经上传
                  (0, _order.postOrderOverdue)(_this.orderInfo).then(function (res) {
                    console.log('res', res);
                    _this.loading = false;
                    _this.orderInfo.is_report_credit = 1;
                    _this.$emit('getList', true);
                  }).catch(function () {
                    _this.loading = false;
                  });
                }).catch(function () {
                  _this.loading = false;
                });
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function handleOpenAccount() {
        return _handleOpenAccount.apply(this, arguments);
      }
      return handleOpenAccount;
    }(),
    handleCollectionReport: function handleCollectionReport() {
      var _this2 = this;
      if (this.orderId) {
        this.loading = true;
        console.log('this.orderId', this.orderId);
        var order_id = this.orderId;
        this.$confirm('确认要上报催收吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          (0, _order.addCompensatory)({
            order_id: order_id
          }).then(function (res) {
            console.log('res', res);
            _this2.loading = false;
            _this2.orderInfo.is_add_compensatory = 1;
            _this2.$emit('getList', true);
          }).catch(function () {
            _this2.loading = false;
          });
        }).catch(function () {
          _this2.loading = false;
        });
      } else {
        this.$message({
          message: '订单ID不存在',
          type: 'error'
        });
      }
    },
    // 物权证明截图
    handleProofTitleImg: function handleProofTitleImg(val) {
      var _this3 = this;
      (0, _order.setCommodityCertificate)({
        orderId: this.orderId,
        images: val,
        target: 'proof_title_img'
      }).then(function (res) {
        _this3.infoData.proof_title_img.push(val);
        _this3.$refs.pti.sortList = _this3.infoData.proof_title_img;
      });
    },
    // 短信催收
    handleSMSCompImg: function handleSMSCompImg(val) {
      var _this4 = this;
      (0, _order.setCommodityCertificate)({
        orderId: this.orderId,
        images: val,
        target: 'sms_comp_img'
      }).then(function (res) {
        _this4.infoData.sms_comp_img.push(val);
        _this4.$refs.sci.sortList = _this4.infoData.sms_comp_img;
      });
    },
    //代偿通知
    handleNoticeCompImg: function handleNoticeCompImg(val) {
      var _this5 = this;
      (0, _order.setCommodityCertificate)({
        orderId: this.orderId,
        images: val,
        target: 'notice_comp_img'
      }).then(function (res) {
        _this5.infoData.notice_comp_img.push(val);
        _this5.$refs.nci.sortList = _this5.infoData.notice_comp_img;
      });
    },
    //代偿证明
    handleProofComImg: function handleProofComImg(val) {
      var _this6 = this;
      (0, _order.setCommodityCertificate)({
        orderId: this.orderId,
        images: val,
        target: 'proof_com_img'
      }).then(function (res) {
        _this6.infoData.proof_com_img.push(val);
        _this6.$refs.pfi.sortList = _this6.infoData.proof_com_img;
      });
    },
    proofChange: function proofChange(val) {
      var _this7 = this;
      (0, _order.setOrderVoucher)({
        orderId: this.orderId,
        type: 3,
        images: val
      }).then(function (res) {
        _this7.infoData.sign_proof.push(val);
        _this7.$refs.cropUpload1.sortList = _this7.infoData.sign_proof;
      });
    },
    /**
     * infoData对象字段说明：images——发货凭证，sign_proof——用户签收凭证，
     * SMSCompImg——催收短信截图， NoticeCompImg——代偿通知书截图， proof_com_img-代偿证明截图，ProofTitleImg——物权证明截图，
     **/
    getInfo: function getInfo() {
      var _this8 = this;
      this.loading = true;
      (0, _order.getLogisticInfo)({
        orderId: this.orderId,
        type: this.activeName === 'supplier' ? 1 : 2
      }).then(function (res) {
        _this8.infoData = res || {};
        _this8.infoData.images = _this8.infoData.images ? _this8.infoData.images.split(',') : [];
        _this8.infoData.sign_proof = _this8.infoData.sign_proof ? _this8.infoData.sign_proof.split(',') : [];
        // 新增催收短信截图 代偿通知书截图 物权证明截图
        _this8.infoData.sms_comp_img = _this8.infoData.sms_comp_img ? _this8.infoData.sms_comp_img.split(',') : [];
        _this8.infoData.notice_comp_img = _this8.infoData.notice_comp_img ? _this8.infoData.notice_comp_img.split(',') : [];
        _this8.infoData.proof_com_img = _this8.infoData.proof_com_img ? _this8.infoData.proof_com_img.split(',') : [];
        _this8.infoData.proof_title_img = _this8.infoData.proof_title_img ? _this8.infoData.proof_title_img.split(',') : [];
        _this8.dataList = _this8.infoData.info ? _this8.infoData.info.data : [];
        _this8.loading = false;
        console.log('this.infoData', _this8.infoData);
      }).catch(function (err) {
        _this8.loading = false;
      });
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.getInfo();
      } else {
        this.activeName = 'supplier';
      }
    }
  }
};
exports.default = _default;